<template>
  <div class="page-container">
    <div class="content-wrapper">
      <van-form @submit="onSubmit" :show-error="false">
        <div class="section">
          <h3>您的身份：<span class="required">*</span></h3>
          <div class="identity-buttons">
            <van-button
              :type="identity === 'teacher' ? 'primary' : 'default'"
              @click="onIdentitySelect('teacher')"
            >我是老师</van-button>
            <van-button
              :type="identity === 'parent' ? 'primary' : 'default'"
              @click="onIdentitySelect('parent')"
            >我是家长</van-button>
            <van-button
              :type="identity === 'student' ? 'primary' : 'default'"
              @click="onIdentitySelect('student')"
            >我是学生</van-button>
            <van-button
              :type="identity === 'other' ? 'primary' : 'default'"
              @click="onIdentitySelect('other')"
            >成年人</van-button>
          </div>
        </div>

        <template v-if="identity">
          <div class="section">
            <h3>您所在的省市：<span class="required">*</span></h3>
            <van-field
              v-model="province"
              is-link
              readonly
              label="省份"
              placeholder="请选择省份"
              @click="showProvincePopup = true"
              :rules="[{ required: true, message: '请选择省份' }]"
            />
            <van-popup v-model:show="showProvincePopup" position="bottom">
              <van-picker
                title="选择省份"
                :columns="provinceColumns"
                @confirm="onProvinceSelect"
                @cancel="showProvincePopup = false"
                show-toolbar
              />
            </van-popup>
            <van-field
              v-model="city"
              is-link
              readonly
              label="城市"
              placeholder="请选择城市"
              @click="showCityPopup = true"
              :rules="[{ required: true, message: '请选择城市' }]"
            />
            <van-popup v-model:show="showCityPopup" position="bottom">
              <van-picker
                title="选择城市"
                :columns="cityColumns"
                @confirm="onCitySelect"
                @cancel="showCityPopup = false"
                show-toolbar
              />
            </van-popup>
            <van-field
              v-model="district"
              is-link
              readonly
              label="区县"
              placeholder="请选择区县"
              @click="showDistrictPopup = true"
              :rules="[{ required: true, message: '请选择区县' }]"
            />
            <van-popup v-model:show="showDistrictPopup" position="bottom">
              <van-picker
                title="选择区县"
                :columns="districtColumns"
                @confirm="onDistrictSelect"
                @cancel="showDistrictPopup = false"
                show-toolbar
              />
            </van-popup>
            <van-field
              v-if="identity !== 'other'"
              v-model="school"
              is-link
              readonly
              label="所在学校"
              :placeholder="getSchoolPlaceholder"
              @click="showSchoolPopup = true"
              :rules="[{ required: true, message: '请选择学校' }]"
            />
            <van-popup v-model:show="showSchoolPopup" position="bottom">
              <van-picker
                show-toolbar
                title="选择学校"
                :columns="schoolColumns"
                @confirm="onSchoolSelect"
                @cancel="showSchoolPopup = false"
              />
            </van-popup>
            <van-field
              v-if="school === '其他学校'"
              v-model="customSchoolName"
              label="学校名称"
              placeholder="请输入学校名称"
              :rules="[{ required: true, message: '请输入学校名称' }]"
            />
          </div>

          <div class="section" v-if="identity === 'teacher'">
            <h3>请选择您带的年级和班级：<span class="required">*</span></h3>
            <div 
              v-for="(item, index) in teacherClasses" 
              :key="index"
              class="grade-class-row"
            >
              <van-field
                v-model="item.grade"
                is-link
                readonly
                placeholder="选择年级"
                @click="openGradePicker(index)"
                :rules="[{ required: true, message: '请选择年级' }]"
                class="grade-field"
              />
              <van-field
                v-model="item.class"
                is-link
                readonly
                placeholder="选择班级"
                @click="openClassPicker(index)"
                :rules="[{ required: true, message: '请选择班级' }]"
                class="class-field"
              />
              <van-button 
                v-if="teacherClasses.length > 1" 
                type="danger" 
                size="small"
                @click="removeGradeClass(index)"
                class="remove-btn"
              >删除</van-button>
            </div>
            <div class="add-btn-wrapper">
              <van-button 
                type="primary" 
                size="small" 
                @click="addGradeClass"
              >添加年级班级</van-button>
            </div>

            <!-- 年级选择弹窗 -->
            <van-popup v-model:show="showGradePopup" position="bottom">
              <van-picker
                show-toolbar
                title="选择年级"
                :columns="gradeOptions"
                @confirm="onGradeSelect"
                @cancel="showGradePopup = false"
              />
            </van-popup>

            <!-- 班级选择弹窗 -->
            <van-popup v-model:show="showClassPopup" position="bottom">
              <van-picker
                show-toolbar
                title="选择班级"
                :columns="classOptions"
                @confirm="onClassSelect"
                @cancel="showClassPopup = false"
              />
            </van-popup>
          </div>

          <div class="section" v-if="identity === 'teacher'">
            <h3>您的姓名：<span class="required">*</span></h3>
            <van-field
              v-model="name"
              label="姓名"
              placeholder="请输入您的姓名"
              :rules="[{ required: true, message: '请输入姓名' }]"
            />
          </div>

          <div class="section" v-if="identity === 'parent' || identity === 'student'">
            <template v-if="identity === 'parent'">
              <h3>您孩子的信息：<span class="required">*</span></h3>
              <van-field
                v-model="class_"
                is-link
                readonly
                label="年级"
                placeholder="请选择年级"
                @click="showGradePopup = true"
                :rules="[{ required: true, message: '请选择年级' }]"
              />
              <van-popup v-model:show="showGradePopup" position="bottom">
                <van-picker
                  show-toolbar
                  title="选择年级"
                  :columns="gradeOptions"
                  @confirm="(value) => { class_ = value.selectedValues[0]; showGradePopup = false }"
                  @cancel="showGradePopup = false"
                />
              </van-popup>

              <van-field
                v-model="childClass"
                label="班级"
                placeholder="请输入班级，如1班"
                :rules="[{ required: true, message: '请输入班级' }]"
              />

              <van-field
                v-model="childTeacher"
                label="班主任"
                placeholder="请输入班主任姓名"
                :rules="[{ required: true, message: '请输入班主任姓名' }]"
              />

              <van-field
                v-model="childGender"
                is-link
                readonly
                label="性别"
                placeholder="请选择性别"
                @click="showChildGenderSheet = true"
                :rules="[{ required: true, message: '请选择性别' }]"
              />
              <van-action-sheet
                v-model:show="showChildGenderSheet"
                :actions="genderActions"
                @select="onChildGenderSelect"
                cancel-text="取消"
                close-on-click-action
              />

              <van-field
                v-model="childName"
                label="姓名"
                placeholder="请输入孩子姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
              />
            </template>

            <template v-else>
              <h3>您当前的学习阶段：</h3>
              <van-field
                v-model="class_"
                is-link
                readonly
                label="年级"
                placeholder="请选择年级"
                @click="showGradePopup = true"
                :rules="[{ required: true, message: '请选择年级' }]"
              />
              <van-popup v-model:show="showGradePopup" position="bottom">
                <van-picker
                  show-toolbar
                  title="选择年级"
                  :columns="gradeOptions"
                  @confirm="(value) => { class_ = value.selectedValues[0]; showGradePopup = false }"
                  @cancel="showGradePopup = false"
                />
              </van-popup>
            </template>
          </div>

          <div class="section" v-if="identity === 'other'">
            <h3>您的信息：<span class="required">*</span></h3>
            <van-field
              v-model="name"
              label="姓名"
              placeholder="请输入您的姓名"
              :rules="[{ required: true, message: '请输入姓名' }]"
            />
            <van-field
              v-model="gender"
              is-link
              readonly
              label="性别"
              placeholder="请选择性别"
              @click="showGenderSheet = true"
              :rules="[{ required: true, message: '请选择性别' }]"
            />
            <van-action-sheet
              v-model:show="showGenderSheet"
              :actions="genderActions"
              @select="onGenderSelect"
              cancel-text="取消"
              close-on-click-action
            />
            <van-field
              v-model="age"
              type="number"
              label="年龄"
              placeholder="请输入年龄"
              :rules="[
                { required: true, message: '请填写年龄' },
                { pattern: /^(?:[1-9][0-9]?|1[01][0-9]|120)$/, message: '请输入1-120之间的年龄' }
              ]"
            />
            <van-field
              v-model="occupation"
              label="职业"
              placeholder="请输入职业"
              :rules="[{ required: true, message: '请填写职业' }]"
            />
          </div>

          <div class="section" v-if="identity && identity !== 'teacher'">
            <h3>您的学习时间：<span class="required">*</span></h3>
            <div class="week-select">
              <h4>每周可上课时间（可多选）：</h4>
              <div class="week-days">
                <van-button
                  v-for="day in weekDays"
                  :key="day.value"
                  :type="selectedWeekDays.includes(day.value) ? 'primary' : 'default'"
                  size="small"
                  @click="toggleWeekDay(day.value)"
                >
                  {{ day.label }}
                </van-button>
              </div>
            </div>
            <van-field
              v-model="studyTime"
              is-link
              readonly
              name="studyTime"
              label="学习时段"
              placeholder="请选择学习时段"
              @click="showStudyTimePicker = true"
            />
            <van-action-sheet
              v-model:show="showStudyTimePicker"
              :actions="studyTimeActions"
              @select="onStudyTimeSelect"
              cancel-text="取消"
              close-on-click-action
            />
          </div>

          <div class="submit-btn">
            <van-button round block type="primary" native-type="submit">
              下一步
            </van-button>
          </div>
        </template>
      </van-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'
import { getAllProvinces, getCitiesByProvince, getDistrictsByCity,getSchools } from '@/api/area'
import {  submitUserInfo } from '@/api/user'

export default {
  name: 'UserInfoView',
  setup() {
    const router = useRouter()
    const identity = ref('other') // 默认选择成年人
    const name = ref('')
    const gender = ref('')
    const age = ref('')
    const occupation = ref('')
    const studyTime = ref('')
    const province = ref('')
    const city = ref('')
    const district = ref('')
    const school = ref('')
    const schoolId = ref('')
    const teacherClasses = ref([{ grade: '', class: '' }]) // 老师的年级班级列表
    const class_ = ref('')
    const childClass = ref('')
    const childTeacher = ref('')
    const childGender = ref('')
    const childName = ref('')
    const customSchoolName = ref('')

    const showProvincePopup = ref(false)
    const showCityPopup = ref(false)
    const showDistrictPopup = ref(false)
    const showGradePopup = ref(false)
    const showTimePopup = ref(false)
    const showAgePopup = ref(false)
    const showOccupationPopup = ref(false)
    const showGenderSheet = ref(false)
    const showChildGenderSheet = ref(false)
    const showStudyTimePicker = ref(false)
    const showSchoolPopup = ref(false)
    const showGradePicker = ref(false)
    const showClassPopup = ref(false)
    const currentEditingIndex = ref(0) // 当前正在编辑的年级班级索引

    // 省市区数据
    const provinces = ref([])
    const cities = ref([])
    const districts = ref([])
    const schools = ref([])

    // 省市区选项列表
    const provinceColumns = computed(() => 
      provinces.value?.map(p => ({
        text: p.Name,
        value: p.Code
      })) || []
    )
    
    const cityColumns = computed(() => 
      cities.value?.map(c => ({
        text: c.name,
        value: c.code
      })) || []
    )
    
    const districtColumns = computed(() => 
      districts.value?.map(d => ({
        text: d.name,
        value: d.code
      })) || []
    )

    const schoolColumns = computed(() => {
      const options = schools.value.map(school => ({
        text: school.Name,
        value: school.Id
      }))
      console.log('学校选项:', options)
      return options  // 直接返回选项数组，不需要包装 values
    })

    // 处理省份选择
    const onProvinceSelect = (value) => {
      const selected = value.selectedOptions[0]
      console.log('选择的省份:', selected)
      if (selected) {
        province.value = selected.text
        city.value = ''
        district.value = ''
        loadCities(selected.value)
      }
      showProvincePopup.value = false
    }

    // 处理城市选择
    const onCitySelect = (value) => {
      const selected = value.selectedOptions[0]
      console.log('选择的城市:', selected)
      if (selected) {
        city.value = selected.text
        district.value = ''
        loadDistricts(selected.value)
      }
      showCityPopup.value = false
    }

    // 处理区县选择
    const onDistrictSelect = async (value) => {
      const selected = value.selectedOptions[0]
      console.log('选择的区县:', selected)
      if (selected) {
        district.value = selected.text
        // 清空已选择的学校
        school.value = ''
        schoolId.value = ''
        // 只有非成年人身份才加载学校列表
        console.log('加载学校列表, areaCode:', selected.value)
        if (identity.value !== 'other') {
          await loadSchools(selected.value)
        }
      }
      showDistrictPopup.value = false
    }

    // 处理身份选择
    const onIdentitySelect = (value) => {
      identity.value = value
      // 清空其他字段
      name.value = ''
      gender.value = ''
      age.value = ''
      occupation.value = ''
      province.value = ''
      city.value = ''
      district.value = ''
      school.value = ''
      schoolId.value = ''
      class_.value = ''
      childClass.value = ''
      childTeacher.value = ''
      childGender.value = ''
      childName.value = ''
      selectedWeekDays.value = []
      studyTime.value = ''
      teacherClasses.value = [{ grade: '', class: '' }]
    }

    // 获取省份数据
    const loadProvinces = async () => {
      try {
        console.log('开始加载省份数据')
        const data = await getAllProvinces()
        console.log('省份数据:', data)
        
        if (Array.isArray(data)) {
          provinces.value = data
          console.log('设置省份数据成功, 数据长度:', provinces.value.length)
          console.log('第一条数据:', provinces.value[0])
          console.log('转换后的选项:', provinceColumns.value)
        } else {
          console.error('省份数据格式错误:', data)
          showToast('获取省份数据失败')
        }
      } catch (error) {
        showToast('获取省份数据失败')
        console.error('获取省份失败:', error)
      }
    }

    // 获取城市数据
    const loadCities = async (provinceCode) => {
      try {
        console.log('开始加载城市数据, provinceCode:', provinceCode)
        const data = await getCitiesByProvince(provinceCode)
        console.log('城市数据:', data)
        
        if (Array.isArray(data)) {
          cities.value = data
          console.log('设置城市数据成功, 数据长度:', cities.value.length)
          if (cities.value.length > 0) {
            console.log('第一条数据:', cities.value[0])
            console.log('转换后的选项:', cityColumns.value)
          }
        } else {
          console.error('城市数据格式错误:', data)
          showToast('获取城市数据失败')
        }
      } catch (error) {
        showToast('获取城市数据失败')
        console.error('获取城市失败:', error)
      }
    }

    // 获取区县数据
    const loadDistricts = async (cityCode) => {
      try {
        console.log('开始加载区县数据, cityCode:', cityCode)
        const data = await getDistrictsByCity(cityCode)
        console.log('区县数据:', data)
        
        if (Array.isArray(data)) {
          districts.value = data
          console.log('设置区县数据成功, 数据长度:', districts.value.length)
          if (districts.value.length > 0) {
            console.log('第一条数据:', districts.value[0])
            console.log('转换后的选项:', districtColumns.value)
          }
        } else {
          console.error('区县数据格式错误:', data)
          showToast('获取区县数据失败')
        }
      } catch (error) {
        showToast('获取区县数据失败')
        console.error('获取区县失败:', error)
      }
    }

    // 获取学校数据
    const loadSchools = async (areaCode) => {
      try {
        console.log('开始加载学校数据, areaCode:', areaCode)
        const res = await getSchools(areaCode)
        console.log('学校接口返回数据:', res)
        
        if (res.Success && Array.isArray(res.Data)) {
          schools.value = res.Data
          console.log('学校数据设置成功:', schools.value)
        } else {
          console.error('学校数据格式错误:', res)
          schools.value = []
          showToast('获取学校数据失败')
        }
      } catch (error) {
        console.error('获取学校失败:', error)
        schools.value = []
        showToast('获取学校数据失败')
      }
    }

    // 处理学校选择
    const onSchoolSelect = (value) => {
      console.log('选择的学校:', value)
      if (value && value.selectedOptions && value.selectedOptions[0]) {
        school.value = value.selectedOptions[0].text
        schoolId.value = value.selectedOptions[0].value
        // 如果不是其他学校，清空自定义学校名称
        if (school.value !== '其他学校') {
          customSchoolName.value = ''
        }
      }
      showSchoolPopup.value = false
    }

    // 年级选项
    const gradeOptions = [
      { text: '学前班', value: '学前班' },
      { text: '一年级', value: '一年级' },
      { text: '二年级', value: '二年级' },
      { text: '三年级', value: '三年级' },
      { text: '四年级', value: '四年级' },
      { text: '五年级', value: '五年级' },
      { text: '六年级', value: '六年级' },
      { text: '七年级', value: '七年级' },
      { text: '八年级', value: '八年级' },
      { text: '九年级', value: '九年级' }
    ]

    const classOptions = Array.from({ length: 12 }, (_, i) => ({
      text: `(${i + 1})班`,
      value: `(${i + 1})班`
    }))

    // 处理年级选择
    const onGradeSelect = (value) => {
      console.log('选择的年级:', value)
      teacherClasses.value[currentEditingIndex.value].grade = value.selectedValues[0]
      showGradePopup.value = false
    }

    // 处理班级选择
    const onClassSelect = (value) => {
      console.log('选择的班级:', value)
      teacherClasses.value[currentEditingIndex.value].class = value.selectedValues[0]
      showClassPopup.value = false
    }

    // 添加新的年级班级
    const addGradeClass = () => {
      teacherClasses.value.push({ grade: '', class: '' })
    }

    // 删除年级班级
    const removeGradeClass = (index) => {
      if (teacherClasses.value.length > 1) {
        teacherClasses.value.splice(index, 1)
      }
    }

    // 打开年级选择器
    const openGradePicker = (index) => {
      currentEditingIndex.value = index
      showGradePopup.value = true
    }

    // 打开班级选择器
    const openClassPicker = (index) => {
      currentEditingIndex.value = index
      showClassPopup.value = true
    }

    // 学习时间段选择
    const studyTimeActions = [
      { name: '上午 06:00-08:00' },
      { name: '下午 18:00-20:00' },
      { name: '晚上 20:00-22:00' },
      { name: '其他时间' }
    ]

    const onStudyTimeSelect = (action) => {
      studyTime.value = action.name
      showStudyTimePicker.value = false
    }

    // 年龄选项
    const ageOptions = Array.from({ length: 62 }, (_, i) => `${i + 18}岁`)

    // 职业选项
    const occupationOptions = [
      '公司职员',
      '个体经营',
      '自由职业',
      '企业主管',
      '政府工作人员',
      '医生',
      '工程师',
      '教师',
      '学生',
      '其他'
    ]

    const genderActions = [
      { name: '男' },
      { name: '女' }
    ]

    const onGenderSelect = (action) => {
      gender.value = action.name
    }

    const onChildGenderSelect = (action) => {
      childGender.value = action.name
    }

    // 星期选择
    const weekDays = [
      { label: '周一', value: 1 },
      { label: '周二', value: 2 },
      { label: '周三', value: 3 },
      { label: '周四', value: 4 },
      { label: '周五', value: 5 },
      { label: '周六', value: 6 },
      { label: '周日', value: 7 }
    ]
    const selectedWeekDays = ref([])
    const toggleWeekDay = (value) => {
      const index = selectedWeekDays.value.indexOf(value)
      if (index === -1) {
        selectedWeekDays.value.push(value)
      } else {
        selectedWeekDays.value.splice(index, 1)
      }
    }

    // 获取学校输入框的placeholder
    const getSchoolPlaceholder = computed(() => {
      switch (identity.value) {
        case 'teacher':
          return '请选择您所在的学校'
        case 'parent':
          return '请选择您孩子所在的学校'
        case 'student':
          return '请选择您所在的学校'
        default:
          return '请选择学校'
      }
    })

    const onSubmit = async () => {
      try {
        // 表单验证
        if (!identity.value) {
          showToast('请选择身份')
          return
        }
        if (!province.value || !city.value || !district.value) {
          showToast('请选择所在地区')
          return
        }
        if (identity.value !== 'other' && !school.value) {
          showToast('请选择学校')
          return
        }

        // 根据不同身份验证必填字段
        if (identity.value === 'teacher') {
          if (teacherClasses.value.length === 0 || teacherClasses.value.some(item => !item.grade || !item.class)) {
            showToast('请选择带的年级和班级')
            return
          }
          if (!name.value) {
            showToast('请输入姓名')
            return
          }
        } else if (identity.value === 'parent') {
          if (!childClass.value) {
            showToast('请输入班级')
            return
          }
          if (!childTeacher.value) {
            showToast('请输入班主任姓名')
            return
          }
          if (!childGender.value) {
            showToast('请选择性别')
            return
          }
          if (!childName.value) {
            showToast('请输入孩子姓名')
            return
          }
          // 非教师身份才验证学习时间
          if (selectedWeekDays.value.length === 0) {
            showToast('请选择可学习的时间')
            return
          }
          if (!studyTime.value) {
            showToast('请选择学习时段')
            return
          }
        } else if (identity.value === 'other') {
          if (!name.value) {
            showToast('请输入姓名')
            return
          }
          if (!gender.value) {
            showToast('请选择性别')
            return
          }
          if (!age.value) {
            showToast('请输入年龄')
            return
          }
          if (!occupation.value) {
            showToast('请输入职业')
            return
          }
          // 非教师身份才验证学习时间
          if (selectedWeekDays.value.length === 0) {
            showToast('请选择可学习的时间')
            return
          }
          if (!studyTime.value) {
            showToast('请选择学习时段')
            return
          }
        } else {
          // 学生身份
          // 非教师身份才验证学习时间
          if (selectedWeekDays.value.length === 0) {
            showToast('请选择可学习的时间')
            return
          }
          if (!studyTime.value) {
            showToast('请选择学习时段')
            return
          }
        }

        // 转换身份为对应的数字类型
        const userTypeMap = {
          'student': 1,
          'teacher': 2,
          'other': 3,
          'parent': 4
        }

        // 构建提交数据
        const submitData = {
          userType: userTypeMap[identity.value],
          province: province.value,
          city: city.value,
          county: district.value,
          schoolName: school.value === '其他学校' ? customSchoolName.value : school.value,
          schoolId: school.value === '其他学校' ? '' : schoolId.value,
          state: 0, // 预约中
          grade: class_.value || '',
          class: childClass.value || '',
          childsName: childName.value || name.value || '',
          guardian: childTeacher.value || '',
          age: age.value ? parseInt(age.value) : 0,
          occupation: occupation.value || ''
        }

        // 如果是老师，使用第一个年级班级
        if (identity.value === 'teacher' && teacherClasses.value.length > 0) {
          submitData.grade = teacherClasses.value[0].grade
          submitData.class = teacherClasses.value[0].class
        } else {
          // 非教师身份才添加学习时间
          submitData.studyDaysOfWeek = selectedWeekDays.value.join(',')
          submitData.timeSlot = studyTime.value
        }
        
        console.log(submitData)
        // 发送请求
        const response = await submitUserInfo(submitData)
        if (response.Success) {
          showToast('提交成功')
          router.push('/download')
        } else {
          showToast(response.Msg || '提交失败，请稍后重试')
        }
      } catch (error) {
        console.error('提交失败:', error)
        showToast('提交失败，请稍后重试')
        return
      }
    }

    onMounted(() => {
      console.log('组件挂载，开始加载省份数据')
      loadProvinces()
    })

    return {
      // 基础数据
      identity,
      name,
      gender,
      age,
      occupation,
      studyTime,
      province,
      city,
      district,
      school,
      schoolId,
      teacherClasses,
      childClass,
      childTeacher,
      childGender,
      childName,
      customSchoolName,

      // 弹窗控制
      showProvincePopup,
      showCityPopup,
      showDistrictPopup,
      showGradePopup,
      showClassPopup,
      showGenderSheet,
      showChildGenderSheet,
      showStudyTimePicker,
      showSchoolPopup,

      // 数据列表
      provinces,
      cities,
      districts,
      schools,
      schoolColumns,
      gradeOptions,
      classOptions,
      provinceColumns,  // 添加省份选项
      cityColumns,      // 添加城市选项
      districtColumns,  // 添加区县选项

      // 方法
      onIdentitySelect,
      onProvinceSelect,
      onCitySelect,
      onDistrictSelect,
      onGenderSelect,
      onChildGenderSelect,
      onStudyTimeSelect,
      onSchoolSelect,
      onGradeSelect,
      onClassSelect,
      addGradeClass,
      removeGradeClass,
      openGradePicker,
      openClassPicker,
      toggleWeekDay,
      onSubmit,        // 添加表单提交方法

      // 其他数据
      selectedWeekDays,
      weekDays,
      studyTimeActions,
      genderActions,
      getSchoolPlaceholder,
      class_,          // 添加 class_ 变量
      ageOptions,      // 添加年龄选项
      occupationOptions // 添加职业选项
    }
  }
}
</script>

<style>
.identity-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.identity-buttons .van-button {
  width: 100%;
  border-radius: 8px;
}

:deep(.van-radio-group) {
  display: flex;
  gap: 32px;
}

.week-select {
  margin-bottom: 16px;
}

.sub-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.week-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.week-buttons .van-button {
  flex: 0 0 calc(25% - 6px);
  margin-bottom: 8px;
}

:deep(.van-button--small) {
  padding: 0 12px;
  height: 32px;
}

.grade-class-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
}

.grade-field {
  flex: 1;
}

.class-field {
  flex: 1;
}

.remove-btn {
  flex-shrink: 0;
}

.add-btn-wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>
